<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo.png" height="50" alt="CoreUI Logo" />
        <img class="navbar-brand-minimized" src="img/logo.png" height="50" alt="CoreUI Logo" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none">
<!--        <b-nav-item class="px-3" to="/dashboard">-->
<!--          แบบสอบถามภาวะการมีงานทำของบัณฑิต (Graduate Employability Survey)-->
<!--        </b-nav-item>-->
        <!--<b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <!--<b-nav-item class="px-3">Settings</b-nav-item>-->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-bell"></i>-->
        <!--<b-badge pill variant="danger">5</b-badge>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-list"></i>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-location-pin"></i>-->
        <!--</b-nav-item>-->
        <!--<DefaultHeaderDropdownAccnt/>-->
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block" />-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list" /> -->
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">&copy; 2025 ศูนย์บริการเทคโนโลยีสารสนเทศ มหาวิทยาลัยแม่ฟ้าหลวง</span>
      </div>
      <div class="ml-auto">
        <!-- <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>-->
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import api from "../service/api";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import store from "@/store/store";
export default {
  name: "DefaultContainer2",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      interval: "",
      time: 0,
      isRunning: false,
      active: true,
      keepAlive: false,
      nav: nav.items_report
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      // console.log("sos", store.state.user.levelid);

      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  methods: {

  },
  created() {

  },
};
</script>
